"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetDoubleParagraphSpacingCommand = exports.SetSesquialteralParagraphSpacingCommand = exports.SetSingleParagraphSpacingCommand = exports.SetParagraphSpacingTypeCommandBase = void 0;
var tslib_1 = require("tslib");
var paragraph_properties_1 = require("../../../core/model/paragraph/paragraph-properties");
var add_spacing_after_paragraph_command_1 = require("./add-spacing-after-paragraph-command");
var SetParagraphSpacingTypeCommandBase = (function (_super) {
    tslib_1.__extends(SetParagraphSpacingTypeCommandBase, _super);
    function SetParagraphSpacingTypeCommandBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetParagraphSpacingTypeCommandBase.prototype.getDescriptor = function () {
        return paragraph_properties_1.ParagraphPropertyDescriptor.lineSpacingType;
    };
    SetParagraphSpacingTypeCommandBase.prototype.getValueForState = function (val) {
        return val == this.getSpacingType();
    };
    SetParagraphSpacingTypeCommandBase.prototype.DEPRECATEDConvertOptionsParameter = function (parameter) {
        return this.convertBooleanParameterToEnumType(parameter, this.getSpacingType(), this.getSpacingType());
    };
    return SetParagraphSpacingTypeCommandBase;
}(add_spacing_after_paragraph_command_1.LineSpacingParagraphCommandBase));
exports.SetParagraphSpacingTypeCommandBase = SetParagraphSpacingTypeCommandBase;
var SetSingleParagraphSpacingCommand = (function (_super) {
    tslib_1.__extends(SetSingleParagraphSpacingCommand, _super);
    function SetSingleParagraphSpacingCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSingleParagraphSpacingCommand.prototype.getSpacingType = function () {
        return paragraph_properties_1.ParagraphLineSpacingType.Single;
    };
    return SetSingleParagraphSpacingCommand;
}(SetParagraphSpacingTypeCommandBase));
exports.SetSingleParagraphSpacingCommand = SetSingleParagraphSpacingCommand;
var SetSesquialteralParagraphSpacingCommand = (function (_super) {
    tslib_1.__extends(SetSesquialteralParagraphSpacingCommand, _super);
    function SetSesquialteralParagraphSpacingCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSesquialteralParagraphSpacingCommand.prototype.getSpacingType = function () {
        return paragraph_properties_1.ParagraphLineSpacingType.Sesquialteral;
    };
    return SetSesquialteralParagraphSpacingCommand;
}(SetParagraphSpacingTypeCommandBase));
exports.SetSesquialteralParagraphSpacingCommand = SetSesquialteralParagraphSpacingCommand;
var SetDoubleParagraphSpacingCommand = (function (_super) {
    tslib_1.__extends(SetDoubleParagraphSpacingCommand, _super);
    function SetDoubleParagraphSpacingCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetDoubleParagraphSpacingCommand.prototype.getSpacingType = function () {
        return paragraph_properties_1.ParagraphLineSpacingType.Double;
    };
    return SetDoubleParagraphSpacingCommand;
}(SetParagraphSpacingTypeCommandBase));
exports.SetDoubleParagraphSpacingCommand = SetDoubleParagraphSpacingCommand;
